function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Space, Form, Drawer, Breadcrumb, Descriptions, Modal, DatePicker, Tag, Input, notification } from 'antd';
import { Table } from 'react-bootstrap';
import { ListUl, Search as SearchIcon, CalendarCheckFill, CardImage, PencilSquare, Clipboard2Pulse, GraphUpArrow, HourglassSplit, Upload as UploadIc } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import NewConsultation from "../components/forms/NewConsultation";
import PatientView from "../components/PatientView";
import NewAppointment from "../components/forms/NewAppointment";
import Appointment from "../components/Appointment";
import PatientPage from "./PatientPage";
import Moment from 'react-moment';
import SetImResult from "../components/forms/SetImResult";
import SetImFile from "../components/forms/SetImFile";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var RangePicker = DatePicker.RangePicker;
var Dental = function Dental() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentDept = _useState2[0],
    setCurrentDept = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    deptList = _useState4[0],
    setDeptList = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isDeptDataLoading = _useState6[0],
    setIsDeptDataLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    queueData = _useState8[0],
    setQueueData = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    currentQueueItem = _useState0[0],
    setCurrentQueueItem = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isConsultationDrawerVisible = _useState10[0],
    setIsConsultationDrawerVisible = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    searchId = _useState12[0],
    setSearchId = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isPatientModalOpen = _useState14[0],
    setIsPatientModalOpen = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    dataChanged = _useState16[0],
    setDataChanged = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showCheck = _useState18[0],
    setShowCheck = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showTranslate = _useState20[0],
    setShowTranslate = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showImageInput = _useState22[0],
    setShowImageInput = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    selectedItem = _useState24[0],
    setSelectedItem = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showPatientRecord = _useState26[0],
    setShowPatientRecord = _useState26[1];
  var onSearch = function onSearch(v) {
    setSearchId('');
    if (v.length > 0) {
      setSearchId(v);
      //setIsPatientModalOpen(true); 
    }
  };
  var onSelectPeriodFinish = function onSelectPeriodFinish(values) {};
  useEffect(function () {
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getdepartments").then(function (response) {
      if (response.data.status == 200) {
        setDeptList(response.data.departments);
        var dep;
        dep = response.data.departments.filter(function (d) {
          return d.dcode == 'CAB';
        });

        //let dep = response.data.departments.filter(d => d.dcode == 'CON');    
        var req;
        if (dep.length == 1) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "/" + Common.currentUser.id;
        }
        if (dep.length == 2) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "," + dep[1].id.toString() + "/" + Common.currentUser.id;
        }
        axios.get(req).then(function (qresponse) {
          setQueueData(qresponse.data.queueItems);
          console.log(qresponse.data.queueData);
        })["catch"](function (error) {
          message.error({
            content: error.toString(),
            delay: 4
          });
        })["finally"](function () {
          setIsDeptDataLoading(false);
        });
      }
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  useEffect(function () {
    setInterval(function () {
      setDataChanged(true);
    }, 30000);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsxs(Breadcrumb, {
            children: [/*#__PURE__*/_jsx(Breadcrumb.Item, {
              children: "Traitement"
            }), /*#__PURE__*/_jsx(Breadcrumb.Item, {
              children: /*#__PURE__*/_jsx("a", {
                href: "#",
                children: "Cardiologie"
              })
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(ListUl, {
                  size: 35
                }), " File d'attente"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Dossier"
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 0;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.toString().slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx("ul", {
                            style: {
                              listStyleType: 'none'
                            },
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx("li", {
                                children: /*#__PURE__*/_jsxs(Space, {
                                  direction: "horizontal",
                                  children: [/*#__PURE__*/_jsx(Tag, {
                                    color: "#f50",
                                    children: e.business_account_medical_item.label
                                  }), e.business_account_medical_item.label.includes('CONSUL') || e.business_account_medical_item.label.includes('Consul') || e.business_account_medical_item.label.includes('consul') ? /*#__PURE__*/_jsx(Button, {
                                    type: "link",
                                    icon: /*#__PURE__*/_jsx(Clipboard2Pulse, {
                                      size: 20
                                    }),
                                    onClick: function onClick() {
                                      setCurrentQueueItem(q);
                                      setShowCheck(true);
                                    },
                                    size: "small",
                                    children: /*#__PURE__*/_jsx("b", {
                                      children: " CONSULTER MAINTENANT"
                                    })
                                  }) : /*#__PURE__*/_jsxs(Space, {
                                    direction: "horizontal",
                                    children: [/*#__PURE__*/_jsx(Button, {
                                      type: "link",
                                      icon: /*#__PURE__*/_jsx(CardImage, {
                                        size: 20
                                      }),
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowImageInput(true);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      size: "small",
                                      children: /*#__PURE__*/_jsx("b", {
                                        children: " CLICHET"
                                      })
                                    }), /*#__PURE__*/_jsx(Button, {
                                      type: "link",
                                      icon: /*#__PURE__*/_jsx(PencilSquare, {
                                        size: 20
                                      }),
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowTranslate(true);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      size: "small",
                                      children: /*#__PURE__*/_jsx("b", {
                                        children: " INTERPRET."
                                      })
                                    })]
                                  })]
                                })
                              }, e.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: function onClick() {
                              setCurrentQueueItem(q);
                              setShowPatientRecord(true);
                            },
                            size: "small",
                            children: /*#__PURE__*/_jsx("b", {
                              children: "VOIR DOSSIER"
                            })
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(HourglassSplit, {
                  size: 35
                }), " Historique"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      }), /*#__PURE__*/_jsx("td", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 1;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.toString().slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx("ul", {
                            style: {
                              listStyleType: 'none'
                            },
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx("li", {
                                children: /*#__PURE__*/_jsxs(Space, {
                                  direction: "horizontal",
                                  children: [/*#__PURE__*/_jsx(Tag, {
                                    color: "#f50",
                                    children: e.business_account_medical_item.label
                                  }), e.business_account_medical_item.label.includes('CONSUL') || e.business_account_medical_item.label.includes('Consul') || e.business_account_medical_item.label.includes('consul') ? /*#__PURE__*/_jsx(Button, {
                                    type: "link",
                                    icon: /*#__PURE__*/_jsx(Clipboard2Pulse, {
                                      size: 20
                                    }),
                                    onClick: function onClick() {
                                      setCurrentQueueItem(q);
                                      setShowCheck(true);
                                    },
                                    size: "small",
                                    children: /*#__PURE__*/_jsx("b", {
                                      children: " CONSULTER MAINTENANT"
                                    })
                                  }) : /*#__PURE__*/_jsxs(Space, {
                                    direction: "horizontal",
                                    children: [/*#__PURE__*/_jsx(Button, {
                                      type: "link",
                                      icon: /*#__PURE__*/_jsx(CardImage, {
                                        size: 20
                                      }),
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowImageInput(true);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      size: "small",
                                      children: /*#__PURE__*/_jsx("b", {
                                        children: " CLICHET"
                                      })
                                    }), /*#__PURE__*/_jsx(Button, {
                                      type: "link",
                                      icon: /*#__PURE__*/_jsx(PencilSquare, {
                                        size: 20
                                      }),
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowTranslate(true);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      size: "small",
                                      children: /*#__PURE__*/_jsx("b", {
                                        children: " INTERPRET."
                                      })
                                    })]
                                  })]
                                })
                              }, e.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: function onClick() {
                              setCurrentQueueItem(q);
                              setShowPatientRecord(true);
                            },
                            size: "small",
                            children: /*#__PURE__*/_jsx("b", {
                              children: "VOIR DOSSIER"
                            })
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 2), /*#__PURE__*/_jsxs(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(SearchIcon, {
                  size: 35
                })
              }),
              children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Search, {
                placeholder: "Entrez ID ou Telephone",
                size: "large",
                onSearch: onSearch,
                enterButton: true,
                style: {
                  width: '100%',
                  marginBottom: '20px'
                }
              }), /*#__PURE__*/_jsx("br", {}), searchId.length > 0 && /*#__PURE__*/_jsx(PatientPage, {
                patientId: searchId
              })]
            }, 3), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(CalendarCheckFill, {
                  size: 35
                }), " Rendez-vous"]
              }),
              children: /*#__PURE__*/_jsx(Appointment, {})
            }, 4), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(GraphUpArrow, {
                  size: 35
                }), " Activit\xE9s"]
              }),
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                style: {
                  minHeight: '300px'
                },
                children: /*#__PURE__*/_jsxs(Form, {
                  layout: "horizontal",
                  onFinish: onSelectPeriodFinish,
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "perdiod",
                    rules: [{
                      required: true,
                      message: "Champ obligatoire"
                    }],
                    children: /*#__PURE__*/_jsx(RangePicker, {})
                  }), /*#__PURE__*/_jsx(Button, {
                    htmlType: "submit",
                    type: "primary",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CHERCHER"
                    })
                  })]
                })
              })
            }, 5)]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: isConsultationDrawerVisible,
      title: "Nouvelle consultation",
      width: 370,
      onClose: function onClose() {
        setIsConsultationDrawerVisible(false);
      },
      closable: true,
      children: currentQueueItem != null && /*#__PURE__*/_jsx(NewConsultation, {
        handler: function handler() {
          setDataChanged(true);
        },
        queueId: currentQueueItem.id,
        queueData: queueData,
        patient: currentQueueItem.customer
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["DOSSIER PATIENT N\xBA ", searchId]
      }),
      destroyOnClose: true,
      footer: null,
      open: isPatientModalOpen,
      onCancel: function onCancel() {
        setIsPatientModalOpen(false);
      },
      children: /*#__PURE__*/_jsx(PatientView, {
        pid: searchId
      })
    }), currentQueueItem && currentQueueItem.customer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["DOSSIER PATIENT N\xBA ", currentQueueItem.customer.idnumber]
        }),
        destroyOnClose: true,
        footer: null,
        centered: true,
        width: "96%",
        open: showPatientRecord,
        onCancel: function onCancel() {
          setShowPatientRecord(false);
        },
        children: /*#__PURE__*/_jsx(PatientPage, {
          patientId: currentQueueItem.customer.idnumber
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["CONSULTATION PATIENT N\xBA ", currentQueueItem.customer.idnumber]
        }),
        destroyOnClose: true,
        width: "80%",
        open: showCheck,
        onClose: function onClose() {
          setShowCheck(false);
        },
        children: /*#__PURE__*/_jsx(NewConsultation, {
          patient: currentQueueItem.customer,
          queueData: queueData,
          queueId: currentQueueItem.id,
          handler: function handler() {
            setDataChanged(true);
            setShowCheck(false);
            notification.success({
              message: "Ok!",
              description: "Consultation sauvegardée avec succès"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "INTERPRETATION"
        }),
        destroyOnClose: true,
        width: "80%",
        open: showTranslate,
        onCancel: function onCancel() {
          setShowTranslate(false);
        },
        footer: null,
        children: /*#__PURE__*/_jsx(SetImResult, {
          q_item: currentQueueItem,
          m_item: selectedItem,
          handler: function handler() {
            setShowTranslate(false);
            notification.success({
              message: "Ok!",
              description: "Données enregistrée"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "SAUVEGARDER LE CLICHET"
        }),
        destroyOnClose: true,
        width: "80%",
        open: showImageInput,
        onCancel: function onCancel() {
          setShowImageInput(false);
        },
        footer: null,
        children: /*#__PURE__*/_jsx(SetImFile, {
          q_item: currentQueueItem,
          m_item: selectedItem,
          handler: function handler() {
            setShowImageInput(false);
            notification.success({
              message: "Ok!",
              description: "Données enregistrée"
            });
          }
        })
      })]
    })]
  });
};
export default Dental;